(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recipes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector("#product-recipes");
  if (!section) return;

  const track = section.querySelector(".carousel-track");
  const prevBtn = section.querySelector(".slider-arrow.left");
  const nextBtn = section.querySelector(".slider-arrow.right");
  if (!track) return;

  let items = Array.from(track.children);
  let index = 0;
  let visibleCount = 1;
  let itemWidth = 0;
  let gap = 0;
  let totalItemWidth = 0;
  let maxIndex = 0;

  function measureGap() {
    if (items.length < 2) return 0;
    const rect1 = items[0].getBoundingClientRect();
    const rect2 = items[1].getBoundingClientRect();
    return Math.round(rect2.left - rect1.right);
  }

  function getVisibleCount() {
    const w = window.innerWidth;
    if (w <= 640) return 1;
    if (w <= 1024) return 2;
    return 3;
  }

  function calcSizes() {
    items = Array.from(track.children);
    visibleCount = getVisibleCount();

    if (!items.length) return;

    itemWidth = items[0].getBoundingClientRect().width || 0;
    gap = measureGap() || 0;
    totalItemWidth = itemWidth + gap;
    maxIndex = Math.max(0, items.length - visibleCount);

    // Reset if overflowed
    if (index > maxIndex) index = maxIndex;
  }

  function updateSlide() {
    const containerWidth = track.parentElement.offsetWidth;
    const trackWidth = track.scrollWidth;
    const maxTranslate = trackWidth - containerWidth;
    const rawTranslate = totalItemWidth * index;
    const translateX = Math.min(Math.round(rawTranslate), maxTranslate);

    track.style.transform = `translateX(-${translateX}px)`;
    toggleArrows();
  }

  function toggleArrows() {
    if (items.length <= visibleCount) {
      prevBtn.style.display = "none";
      nextBtn.style.display = "none";
    } else {
      prevBtn.style.display = index === 0 ? "none" : "block";
      nextBtn.style.display = index >= maxIndex ? "none" : "block";
    }
  }

  nextBtn.addEventListener("click", () => {
    if (index < maxIndex) {
      index++;
      updateSlide();
    }
  });

  prevBtn.addEventListener("click", () => {
    if (index > 0) {
      index--;
      updateSlide();
    }
  });

  window.addEventListener("resize", () => {
    calcSizes();
    updateSlide();
  });

  // Wait until images load to measure accurately
  const imgs = track.querySelectorAll("img");
  let loaded = 0;
  imgs.forEach((img) => {
    if (img.complete) loaded++;
    else
      img.addEventListener("load", () => {
        loaded++;
        if (loaded === imgs.length) {
          calcSizes();
          updateSlide();
        }
      });
  });

  // Init after fonts/layout settle
  setTimeout(() => {
    calcSizes();
    updateSlide();
  }, 200);
});

  } catch(e) { console.error(e); }
})();
})();
